import { api } from "../helpers/api";
import { ICreateOrUpdateNotificationBody } from "./apisType";

const createOrUpdateNotification = async (body: ICreateOrUpdateNotificationBody) => {
  return await api.post('/api/v1/admin/notifications/create-or-update', body).then((response: any) => {
    return response;
  });
};

const getNotificationDetail = async (notificationId: any) => {
  return await api.get(`/api/v1/admin/notifications/detail/${notificationId}`).then((response: any) => {
    return response;
  });
};

const getAllNotifications = async (page: any, size: any) => {
  const params = { page, size };
  return await api.get('/api/v1/admin/notifications/all', { params }).then((response: any) => {
    return response;
  });
};

const deleteNotification = async (notificationId: any) => {
  return await api.delete(`/api/v1/admin/notifications/delete/${notificationId}`).then((response: any) => {
    return response;
  });
};

const notificationApis = {
  createOrUpdateNotification,
  getNotificationDetail,
  getAllNotifications,
  deleteNotification
};

export default notificationApis;


